import React from 'react';
import styled from 'styled-components';
import SwiperCore, {
  Keyboard, A11y, Navigation
} from 'swiper';
import {
  Swiper, SwiperSlide
} from 'swiper/react';
import renderSlideComponents from '../renderSlideComponentOptions';
import { Carousel as CarouselProps } from './types/types';

// Import Swiper styles
import 'swiper/swiper-bundle.min.css';

export const Carousel = styled.div`
.swiper-button-prev,
.swiper-button-next {
  color: ${(props: any) => (`${props.theme.secondary}`)};
  background-color: ${(props: any) => (`${props.theme.backgroundColor}`)};
  border-radius: 50%;
  width: 40px;

  @media (max-width: 768px) {
    display: none;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.8);
  }
}

.swiper-button-next:after, .swiper-button-prev:after {
  font-size: 30px !important;
}

@media (max-width: 768px) {
  margin-right: -1rem;
}

.element__width {
  img {
    width: 100%;
  }
}

.swiper-slide {
  p {
    margin-bottom: 0;
  }
}
`;

SwiperCore.use([Keyboard, A11y, Navigation]);

const SlideCarousel = ({
  slides, desktopVisibleSlides, mobileVisibleSlides,
}: CarouselProps) => {
  const renderSlides = () => {
    return (
      slides?.map((item, index) => (
        <SwiperSlide
          tabIndex={null}
          key={index}
          className="element__width"
        >
          {renderSlideComponents(item?.sys?.contentType?.sys?.id || item?.contentfulContentType, item)}
        </SwiperSlide>
      ))
    );
  };

  return (
    slides?.length > 0
    && (
    <Carousel data-testid="carousel">
      <Swiper
        className="carousel carousel__container"
        spaceBetween={10}
        slidesPerView={mobileVisibleSlides}
        navigation
        watchOverflow
        observer
        observeParents
        freeMode
        breakpoints={{
          // when window width is >= 769px
          769: {
            freeMode: false,
            slidesPerView: desktopVisibleSlides,
            spaceBetween: 30,
            slidesPerGroup: desktopVisibleSlides,
          },
        }}
        keyboard={{ enabled: true }}
      >
        {renderSlides()}
      </Swiper>
    </Carousel>
    )
  );
};

export default SlideCarousel;
